<template>
  <div class="q-mb-lg">
    <q-breadcrumbs separator="/">
      <q-breadcrumbs-el
        v-for="(item, index) of items"
        :key="index"
        :to="item.to"
        :label="item.label"
        :icon="item.icon"
      />
    </q-breadcrumbs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      currentDoctor: 'breadcrumbs/doctor',
    }),
    items() {
      const items = [
        {
          to: { name: 'Dashboard' },
          label: this.$t('breadcrumbs.dashboard'),
        },
      ];

      if (
        this.$route.name == 'DoctorsIndex' ||
        this.$route.name == 'DoctorsShow'
      ) {
        items.push({
          to: { name: 'DoctorsIndex' },
          label: this.$t('breadcrumbs.doctors'),
        });

        if (this.$route.name == 'DoctorsShow') {
          items.push({
            to: {
              name: 'DoctorsShow',
              params: {
                doctorId: this.$route.params.doctorId,
              },
            },
            label: this.$t('breadcrumbs.doctor', {
              name: this.currentDoctor,
            }),
          });
        }
      } else if (this.$route.name === 'Account') {
        items.push({
          to: { name: 'Account' },
          label: this.$t('breadcrumbs.account'),
        });
      }

      return items;
    },
  },
};
</script>
